import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FieldState } from '../_reducers/field.reducers';

const getFieldFeatureState = createFeatureSelector<FieldState>('field');

export const getFieldsLoading = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.fieldsLoading
);

export const getAllFieldsLoading = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.allFieldsLoading
);

export const getLookupFieldsLoading = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.lookupFieldsLoading
);

export const getSummarizableFieldsLoading = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.summarizableLoading
);

export const getFieldTypesLoading = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.typesLoading
);

export const getFieldById = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.fieldById
);

/**
 * Select fields
 */
export const getFields = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.field
);

/**
 * Select fields types
 */
export const getFieldTypes = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.types
);

/**
 * Select operations
 */
export const getFieldOperations = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.operations
);

/**
 * Select lookup fields
 */
export const getLookupFields = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.lookupFields
);

/**
 * Select summarizable fields
 */
export const getSummarizableFields = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.summarizable
);

/**
 * Select summary fields
 */
 export const getSummaryFields = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.summary
);

/**
 * Select field dependencies
 */
 export const getFieldDependencies = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.fieldDependencies
);

/**
 * Select dependent fields
 */
export const getDependentFields = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.dependentFields
);

/**
 * Select error
 */
export const getError = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.error
);
/**
 * Select error
 */
export const getCreateMultipleFieldError = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.createFieldsError
);


export const getSummaryFormFieldById = createSelector(
  getFieldFeatureState,
  (state: FieldState) => state.summaryFieldById
);
